import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'al-full-screen-loader',
  imports: [CommonModule, LoaderComponent],
  template: `
    <div class="eva-3-container -sm">
      <al-loader></al-loader>
    </div>
  `,
  styleUrls: ['./full-screen-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FullScreenLoaderComponent {}
